module.exports = __webpack_public_path__ + "img/goodsrope3.d2867a49.png";